import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';

class PersonList extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props) {
        super(props);

        this.state = {};
    }
    goToInfo = item => {
        if (item.url) {
            window.open(item.url);
        }
    };
    render() {
        const {
            content: { content = [] },
        } = this.props;

        return (
            <div>
                {content[0] && content[0].child ? (
                    content.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className={styles.title}>{item.type}</div>
                                <div className={styles.personList}>
                                    {item.child.map((child, i) => {
                                        return (
                                            <div
                                                className={styles.item}
                                                onClick={this.goToInfo.bind(this, child)}
                                                key={i}>
                                                <img src={child.src} alt="" />
                                                <span className={styles.name}>{child.title}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className={styles.personList}>
                        {content.map((item, index) => {
                            return (
                                <div className={styles.item} onClick={this.goToInfo.bind(this, item)} key={index}>
                                    <img src={item.src} alt="" />
                                    <span className={styles.name}>{item.title}</span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(PersonList);
